import { useState } from "react";
import styles from "./styles.module.css";
import { MetaAplicacaoRecurso } from "../../../model/PlanoDeTrabalho/PlanoAplicacao";

type Props = {
  appObj: MetaAplicacaoRecurso;
  children?: any;
};

const RowAplicacaoRecurso = ({ appObj, children }: Props) => {
  const [openModal, setModal] = useState(false);
  return (
    <tr className={styles.row}>
      <td className={styles.center}>
        {appObj.etapa}.{appObj.fase}
      </td>
      <td>{appObj.especificacao}</td>
      <td className={styles.dozeAvos}>
        <strong>Unidade: </strong> <br />
        {appObj.unidade_medida}
        <hr className={styles.divisao} />
        <strong>Quantidade: </strong> <br />
        {appObj.quantidade}
      </td>
      <td className={styles.dozeAvos}>
        <strong>Unitário: </strong>
        <br />
        R$ {appObj.custo_unitario.toFixed(2)}
        <hr className={styles.divisao} />
        <strong>Total: </strong>
        <br /> R$ {(appObj.custo_unitario * appObj.quantidade).toFixed(2)}
      </td>
      <td className={styles.dozeAvos}>
        <strong>Público: </strong>
        <br /> R$ {appObj.valor_parceiro_publico.toFixed(2)}
        <hr className={styles.divisao} />
        <strong>Privado: </strong>
        <br /> R$ {appObj.valor_parceiro_privado.toFixed(2)}
      </td>
      {children && <td className={styles.btncoll}>{children}</td>}
    </tr>
  );
};
export default RowAplicacaoRecurso;
